module.exports = __webpack_public_path__ + "static/media/tdsengland.1640b15d.png";